/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="/js/lib/markerwithlabel.js" />
/// <reference path="/js/viz/map/LabelEngine.js" />
/// <reference path="https://maps.googleapis.com/maps/api/js"/>
/// <reference path="~/js/viz/map/config/MapConfig.js"/>

(function($, _, velir, google) {
  var ns = window.nspace("ccc.viz.map.views");

  var pushNycClick = function(response, selectedFips) {
    var location = "New York City";
    if (
      selectedFips &&
      response &&
      response.locationsByFips &&
      response.locationsByFips[selectedFips]
    ) {
      location = response.locationsByFips[selectedFips].name || "New York City";
    }

    // Tracks if user clicks on the map on the "Explore Data" page
    dataLayer.push({
      event: "Explore Map Clicks",
      eventCategory: "Interactive Clicks",
      eventAction: "Explore Map|" + location,
      eventLabel: window.location.pathname
    });
  };

  ns.GoogleMapView = Backbone.View.extend({
    el: "#gmap-container",

    initialize: function(options) {
      this.initialRenderPromise = $.Deferred();

      var self = this;

      _.bindAll(
        this,
        "render",
        "findAndDrawPolygon",
        "preLoadPolygons",
        "selectRegion",
        "drawSelectedRegion"
      );

      this.dispatcher = options.dispatcher;
      this.polygonManager = ccc.viz.map.layers.PolygonManager;
      this.currentMouseover = {};
      this.dataResponseModel = options.dataResponseModel;
      this.initializeMap();

      // When the user's selections change, rerender the map
      this.model.on("change", this.render);

      // When the location type ID changes, pre load the new polygons
      this.model.on("change:locationTypeId", this.preLoadPolygons);

      // When the selectedFips changes, redraw the highlighted polygon
      this.model.on("change:selectedFips", this.drawSelectedRegion);

      // Prevent mouseover popups from getting "stuck" when quickly mousing off the map
      this.$el.on("mouseleave", function() {
        // Remove any previously drawn polygon
        if (self.currentMouseover && self.currentMouseover.polygon) {
          self.currentMouseover.polygon.setMap(null);
          self.currentMouseover = null;
        }
        self.dispatcher.trigger("mouseoff-region");
      });

      // The above change event isn't emitted upon initialization (only on subsequent changes)
      // so manually trigger initial draw
      this.drawSelectedRegion();
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    initializeMap: function() {
      var self = this;

      // GMap styles
      var styles = [
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#8d8d8d" }, { lightness: 17 }]
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 20 }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }]
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: 18 }]
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: 16 }]
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }]
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 }
          ]
        },
        {
          elementType: "labels.text.fill",
          stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }]
        },
        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#f2f2f2" }, { lightness: 19 }]
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }]
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }]
        }
      ];

      var config = ccc.viz.map.config.MapConfig;

      var mapOptions = {
        // Show NYC upon load
        center: new google.maps.LatLng(40.72332, -74.0039),
        zoom: 10,

        // Roadmap
        mapTypeId: google.maps.MapTypeId.ROADMAP,

        // Map Controls
        panControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        scrollwheel: false,

        // Min/max zoom
        minZoom: config.minZoom,
        maxZoom: config.maxZoom,

        // So stylee!
        styles: styles
      };

      // Notify other components that we're about to load the map
      this.gmapLoading = $.Deferred();
      this.dispatcher.trigger("gmap-busy");
      this.dispatcher.trigger("add-task", {
        name: "gmap-loading",
        text: "Loading base map..."
      });

      // Load the map
      this.gmap = new google.maps.Map(this.$el[0], mapOptions);

			this.labelEngine = new CCCLabelEngine(this.gmap);

      // Listen for the map to finish loading and emit an event. Map MUST finish loading before a choropleth overlay can be added,
      // otherwise no map projection will be set.
      google.maps.event.addListenerOnce(this.gmap, "idle", function() {
        self.gmapLoading.resolve();
        self.dispatcher.trigger("gmap-idle");
        self.dispatcher.trigger("end-task", { name: "gmap-loading" });


				// Google Maps seems to like to refresh the map markers when panning the map
				// This causes the MarkerWithLabels' class list to get reset to the initial provided values
				// There doesn't seem to be a good way to prevent this and keep the markers displayed while panning
				// For now, just re-render the markers on idle (finished panning/zooming/toggling full screen)
				self.renderLabels();
				google.maps.event.addListener(self.gmap, 'idle', () => self.renderLabels());
      });

      // Listen for the mouse to move over the map and draw polygons as necessary
      google.maps.event.addListener(
        this.gmap,
        "mousemove",
        self.findAndDrawPolygon
      );

      // Listen for clicks on the map and select the clicked region
      google.maps.event.addListener(this.gmap, "click", self.selectRegion);
    },

		renderLabels: function(takeScreenshot) {			
			this.labelEngine.renderLabels(this.overlayMarkers, this.addLoadingLabelsTask(), this.updateLabelsTaskDone(takeScreenshot));
		},

		addLoadingLabelsTask: function() {
			var self = this;
			return () => {
				self.dispatcher.trigger("add-task", { name: "choropleth-labels-loading", text: "Loading labels..." });
			};
		},

		updateLabelsTaskDone: function(takeScreenshot) {
			var self = this;			
			return () => {
        self.dispatcher.trigger("end-all-tasks", { name: "choropleth-labels-loading" });
        
        if (takeScreenshot && window.triggerScreenshot instanceof Function) {
          window.triggerScreenshot();
        }
			};
		},

    preLoadPolygons: function() {
      this.polygonManager.loadPolygons(this.model.get("locationTypeId"));
    },

    render: function() {
      var self = this;

      // The above "change:locationTypeId" event isn't emitted upon initialization (only on subsequent changes)
      // so manually trigger polygon preloading
      this.preLoadPolygons();

      $.when(this.gmapLoading).done(function() {
        // Don't bother re-rendering if the only change was to the selectedFips. That's handled elsewhere.
        if (
          _.size(self.model.changed) === 1 &&
          self.model.changed.hasOwnProperty("selectedFips")
        ) {
          return;
        }

        // Assemble a filter string from the model
        var parms = ccc.viz.util.UrlParams;

        var filterString = new velir.collections.NameValueCollection();
        filterString.add(parms.indicator, self.model.get("indicatorId"));
        filterString.add(parms.timeFrame, self.model.get("timeFrameId"));
        filterString.add(parms.locationType, self.model.get("locationTypeId"));
        filterString.add(parms.dataFormat, self.model.get("dataFormatId"));
        filterString.add(
          parms.characteristic,
          self.model.get("characteristicId")
        );

        self.updateChoropleth(filterString.toQueryString());
      });
    },

		overlayMarkers: null,
		removeOverlayMarkers: function () {
			// Remove old markers
			if (this.overlayMarkers) {
				for (var index in this.overlayMarkers) {
					var marker = this.overlayMarkers[index];
					if (marker && marker.setMap) {
						marker.setMap(null);
					}
				}
			}
		},

		setLabelTimeout: function(cb) {
			// Google maps renders map markers (like our labels) asynchronously
			// There's no event to tell when it's done - "idle" doesn't work
			// So we just have to wait, based on how many markers there are
			var delayPerMarker = 13; // 10 works fine, but include a buffer
			var delayLength = this.overlayMarkers.length * delayPerMarker;
			console.debug('delayLength', delayLength);
			setTimeout(cb, delayLength);
		},

		getOverlayLabels: function () {
			console.debug('getOverlayLabels start');
			let self = this;
			self.removeOverlayMarkers();

			const zipcodesOverlayTypeId = '4';
			var labelClasslist = "overlay-label overlay-label--hidden"; // Hide labels until we're ready, once LabelGun prunes the overlapping ones
			var overlayTypeIds = self.model.get("overlays");
			if (overlayTypeIds === zipcodesOverlayTypeId ||
				(overlayTypeIds instanceof Array && overlayTypeIds.indexOf(zipcodesOverlayTypeId) >= 0)) {
				labelClasslist += " overlay-label--small"; // Use smaller font for zipcodes
			}

			// global
			var hardcodedPositions = hardcodedPositionsByOverlayTypeAndFips;
			$.get('/api/MapData/GetWktOverlayPolygons?overlays=' + self.model.get("overlays")).done(function successCallback(response) {
				// Remove references to the marker objects as late as possible
				// Doing this too soon results in orphaned markers after zooming
				// This is because Google's setMap() is asynchronous
				// See removeOverlayMarkers()
				self.overlayMarkers = [];

				// Parse out the WKT text into google API Polygons
				for (var key in response) {
					var tokens = key.split('|');
					var overlayType = tokens[0];
					var fips = tokens[1];
					var labelContent = tokens[2];

					var wktPolygon = response[key];

					var polygon = ccc.viz.map.util.MapUtil.wktToGooglePolygon(wktPolygon);

					// Add label marker for the polygon
					var noIcon = {
						// Workaround to have a label with no icon
						path: google.maps.SymbolPath.CIRCLE,
						scale: 0
					};							
					
					// account for label text itself
					var labelXOffset = 5 + fips.length * 4;
					var labelYOffset = 15;
					var labelAnchor = new google.maps.Point(labelXOffset, labelYOffset);
					
					// hardcoded positions
					var positions;
					if (hardcodedPositions && hardcodedPositions[overlayType]) {
						positions = hardcodedPositions[overlayType][fips];
					}
					
					if (!positions || !positions.length) {
						// Just need one label - position over geometric center
						var center = polygon.getBounds().getCenter();
						self.overlayMarkers.push(new MarkerWithLabel({
							map: self.gmap,
							position: center,
							icon: noIcon,
							labelContent: labelContent,
							labelAnchor: labelAnchor,
							labelClass: labelClasslist
						}));
					}
					else {
						positions.forEach(position => {
							// Hardcoded positions, and possibly multiple labels for gerrymandered/multipolygon locations
							self.overlayMarkers.push(new MarkerWithLabel({
								map: self.gmap,
								position: new google.maps.LatLng(position[0], position[1]),
								icon: noIcon,
								labelContent: labelContent,
								labelAnchor: labelAnchor,
								labelClass: labelClasslist
							}));
						});
					}
				} // foreach key in response

				self.renderLabels(true);

				console.debug('getOverlayLabels end');
			}) // $.get().done()
			.fail(function errorCallback(err) {
				console.error('Failed to get overlay label data. ', err);
			}); // $.get()
		}, // getOverlayLabels()

    updateChoropleth: function(filterString) {
      var self = this;

      // Assume the choropleth layer is the bottom-most overlay. Remove the old layer
      if (this.gmap.overlayMapTypes.length > 0) {
        this.gmap.overlayMapTypes.removeAt(0);
      }

      // Add a new layer
      this.choroplethOverlay = new ccc.viz.map.layers.ChoroplethMapType(
        this.gmap.getProjection(),
        filterString,
        self.model.get("overlays")
      );
      this.gmap.overlayMapTypes.push(this.choroplethOverlay);

			self.getOverlayLabels();

      // Emit an event whenever the layer is busy
      $(this.choroplethOverlay).bind("busy", function() {
        self.dispatcher.trigger("add-task", {
          name: "choropleth-overlay-busy",
          text: "Updating data overlay..."
        });
      });

      // Emit an event when the layer finishes loading
      $(this.choroplethOverlay).bind("idle", function() {
        self.dispatcher.trigger("end-all-tasks", {
          name: "choropleth-overlay-busy"
        });
        self.initialRenderPromise.resolve();
      });
    },

    findAndDrawPolygon: function(mouseEvent) {
      var self = this;

      var locTypeId = self.model.get("locationTypeId");
      this.polygonManager.findPolygon(locTypeId, mouseEvent.latLng, function(
        polygonInfo
      ) {
        function removePrevious() {
          // Remove any previously drawn polygon
          if (self.currentMouseover && self.currentMouseover.polygon) {
            self.currentMouseover.polygon.setMap(null);
            self.currentMouseover = null;
          }
        }

        // Not over a polygon currently?
        if (polygonInfo == null) {
          removePrevious();
          self.dispatcher.trigger("mouseoff-region");
          return;
        }

        // Over a polygon? Is it still the same one?
        if (
          self.currentMouseover &&
          polygonInfo.fips == self.currentMouseover.fips
        ) {
          // Nothing to do
          return;
        }

        // Over a polygon, but NOT the same one? Remove the previous and draw the new!
        removePrevious();
        polygonInfo.polygon.setOptions(
          ccc.viz.map.config.MapConfig.mouseoverPolygonStyle
        );
        polygonInfo.polygon.setMap(self.gmap);

        // Events don't propagate
        google.maps.event.addListener(
          polygonInfo.polygon,
          "click",
          self.selectRegion
        );
        self.currentMouseover = polygonInfo;
        self.dispatcher.trigger("mouseover-region", {
          latLng: mouseEvent.latLng,
          gmap: self.gmap,
          fips: polygonInfo.fips
        });
      });
    },

    selectRegion: function(mouseEvent) {
      var self = this;

      // Figure out where the user clicked and highlight/dehighlight regions as necessary
      var locTypeId = self.model.get("locationTypeId");
      this.polygonManager.findPolygon(locTypeId, mouseEvent.latLng, function(
        polygonInfo
      ) {
        // Update the model
        var selectedFips = polygonInfo == null ? null : polygonInfo.fips;

        // If we clicked on NYC data, don't show anything else, since NYC data is already showing.
        if (+selectedFips === ccc.viz.map.config.MapConfig.nycFips) {
          $(".legend-column")
            .stop(true, true)
            .hide()
            .fadeIn();
          return;
        }

        self.model.set("selectedFips", selectedFips);

        var response = self.dataResponseModel.get("response");
        self.debounceExploreMapClicks(response, selectedFips);
      });
    },

    debounceExploreMapClicks: _.debounce(pushNycClick, 100),

    drawSelectedRegion: function() {
      var self = this;

      function removePrevious() {
        // Remove the polygon for the previously selected region, if any
        if (self.selectedPolygonInfo) {
          self.selectedPolygonInfo.innerPolygon.setMap(null);
          self.selectedPolygonInfo.outerPolygon.setMap(null);
          self.selectedPolygonInfo = null;
        }
      }

      // Anything selected?
      // NOTE: "a" is the default value in the URL for when a parameter is absent. That _shouldn't_
      // NOTE: won't collide with any actual FIPS values. Probably.
      var fips = this.model.get("selectedFips");
      if (fips == null || fips == "a") {
        removePrevious();
        return;
      }

      // We have something selected, but was it already selected?
      if (self.selectedPolygonInfo && self.selectedPolygonInfo.fips === fips) {
        // Nothing to do
        return;
      }

      // New selection. Find the polygon for the selected fips and draw it
      var locTypeId = self.model.get("locationTypeId");
      this.polygonManager.getPolygonByFips(locTypeId, fips, function(
        polygonInfo
      ) {
        if (!polygonInfo) {
          throw "Could not find polygon for FIPS: " + fips;
        }

        // PolygonManager returns the same polygon instance every time, so clone the polygon
        // so that it's a different instance than the one drawn for mouseovers
        polygonInfo.innerPolygon = self.polygonManager.clonePolygon(
          polygonInfo.polygon
        );
        polygonInfo.outerPolygon = self.polygonManager.clonePolygon(
          polygonInfo.polygon
        );

        // Draw it
        removePrevious();
        polygonInfo.innerPolygon.setOptions(
          ccc.viz.map.config.MapConfig.selectedPolygonInnerStyle
        );
        polygonInfo.innerPolygon.setMap(self.gmap);
        polygonInfo.outerPolygon.setOptions(
          ccc.viz.map.config.MapConfig.selectedPolygonOuterStyle
        );
        polygonInfo.outerPolygon.setMap(self.gmap);
        self.selectedPolygonInfo = polygonInfo;
      });
    }
  });
})(jQuery, _, velir, google);
